import { render, staticRenderFns } from "./tableSeragam.vue?vue&type=template&id=0cc523dd&scoped=true"
import script from "./tableSeragam.vue?vue&type=script&lang=js"
export * from "./tableSeragam.vue?vue&type=script&lang=js"
import style0 from "./tableSeragam.vue?vue&type=style&index=0&id=0cc523dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc523dd",
  null
  
)

export default component.exports